
export const EditRecordModalList = [
    {
        label: "GoogleMap",
        value: 'mapUrl',
        key: "mapUrl",
        type: "text",
        placeholder: "請輸入GoogleMap網址",
        required: true
    },
    {
        label: "運送日期",
        value: 'deliveryDate',
        key: "deliveryDate",
        type: "date",
        placeholder: "請輸入運送日期",
        required: true
    },
    {
        label: "行駛時間(s)",
        value: 'drivingTime',
        key: "drivingTime",
        type: "text",
        step: "any",
        placeholder: "請輸入行駛時間",
        required: true,
    },
    {
        label: "總重量(kg)",
        value: 'weight',
        key: "weight",
        type: "number",
        step: "any",
        placeholder: "請輸入總重量",
        required: true,
    },
    {
        label: "總距離(km)",
        value: 'drivingKm',
        key: "drivingKm",
        type: "number",
        step: "any",
        placeholder: "請輸入總距離",
        required: true,
    },
    {
        label: "減碳量",
        value: 'carbonReduction',
        key: "carbonReduction",
        type: "number",
        step: "any",
        placeholder: "請輸入減碳量",
        required: true,
    },
]

export const CreateRecordModalList = [
    {
        label: "GoogleMap",
        name: "mapUrl",
        type: "text",
        placeholder: "請輸入GoogleMap網址",
        required: true,
    },
    {
        label: "運送日期",
        name: "deliveryDate",
        type: "date",
        placeholder: "請輸入運送日期",
        required: true,
    },
    {
        label: "總距離",
        name: "drivingKm",
        type: "number",
        step: "any",
        placeholder: "請輸入總距離",
        required: true
    },
]